// CSV serialization for Manufacturing → Slot label line assignments.

import type { SlotCleanupMaterialLine } from "@/lib/manufacturing/slotLabelCleanupClient";

export const SLOT_LABEL_LINE_EXPORT_HEADERS = [
  "line_id",
  "recipe_code",
  "material_code",
  "material_name",
  "line_quantity",
  "slot_label",
] as const;

const NEEDS_QUOTING = /[",\n\r]/;

function escapeCell(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = typeof value === "string" ? value : String(value);
  if (!NEEDS_QUOTING.test(s)) return s;
  return `"${s.replace(/"/g, '""')}"`;
}

function rowsToCsv(headers: readonly string[], rows: Array<Array<unknown>>): string {
  const lines = [headers.join(",")];
  for (const row of rows) {
    lines.push(row.map(escapeCell).join(","));
  }
  return lines.join("\n") + "\n";
}

/** Serialize cleanup lines for bulk import round-trip. */
export function slotLabelLinesToCsv(lines: ReadonlyArray<SlotCleanupMaterialLine>): string {
  const rows = lines.map((ln) => [
    ln.line_id,
    ln.recipe_code,
    ln.material_code,
    ln.material_name,
    ln.quantity,
    ln.slot_label,
  ]);
  return rowsToCsv(SLOT_LABEL_LINE_EXPORT_HEADERS, rows);
}
